import { CustomerState } from '@/config/store/customer/type';

export const state: CustomerState = {
  me: null,
  shoppingCart: null
};